import { MessageCircle, Phone } from "lucide-react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { trackPhoneClick, trackWhatsAppClick } from "@/lib/gads";

const whatsappUrl =
  "https://wa.me/919894105887?text=Hi%2C%20I%20need%20today%27s%20price%20for%20steel%20pipes.%20Please%20send%20me%20a%20quote.";

export const isTodayQuoteRoute = (pathname: string) =>
  pathname === "/steel-price-today" ||
  pathname.startsWith("/blog/") ||
  pathname.startsWith("/price-lists/");

const TodayQuoteBar = () => {
  const { pathname } = useLocation();

  if (!isTodayQuoteRoute(pathname)) return null;

  return (
    <aside
      aria-label="Get today's steel quote"
      className="fixed inset-x-3 bottom-3 z-[70] mx-auto max-w-3xl border border-primary-foreground/15 bg-primary p-3 shadow-2xl sm:bottom-5 sm:flex sm:items-center sm:justify-between sm:gap-5 sm:px-5"
    >
      <p className="mb-3 text-center font-display text-lg font-semibold text-primary-foreground sm:mb-0 sm:text-left">
        Need today&apos;s steel price?
      </p>
      <div className="grid grid-cols-2 gap-2 sm:flex sm:shrink-0">
        <Button asChild variant="outline" className="border-primary-foreground/30 bg-primary text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground">
          <a href="tel:+919894105887" onClick={trackPhoneClick} aria-label="Call Taher Steel for today's quote">
            <Phone aria-hidden="true" />
            Call Now
          </a>
        </Button>
        <Button asChild className="bg-accent text-accent-foreground hover:bg-accent/90">
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={trackWhatsAppClick}
            aria-label="Request today's quote on WhatsApp"
          >
            <MessageCircle aria-hidden="true" />
            WhatsApp
          </a>
        </Button>
      </div>
    </aside>
  );
};

export default TodayQuoteBar;